import type { User, UserCreate, UserUpdate, ResetPassword } from "@iso27001/shared";
import { apiFetch } from "./client.js";

export const usersApi = {
  list: () => apiFetch<{ items: User[] }>("/api/users"),
  listAll: () => apiFetch<{ items: User[] }>("/api/users/all"),
  create: (b: UserCreate) =>
    apiFetch<User>("/api/users", { method: "POST", body: JSON.stringify(b) }),
  update: (id: number, b: UserUpdate) =>
    apiFetch<User>(`/api/users/${id}`, { method: "PATCH", body: JSON.stringify(b) }),
  remove: (id: number) =>
    apiFetch<null>(`/api/users/${id}`, { method: "DELETE" }),
  resetPassword: (id: number, b: ResetPassword) =>
    apiFetch<null>(`/api/users/${id}/reset-password`, { method: "POST", body: JSON.stringify(b) }),
};
